import { render, staticRenderFns } from "./redirectUrlScanPay.vue?vue&type=template&id=2a407a5f&scoped=true&"
import script from "./redirectUrlScanPay.vue?vue&type=script&lang=js&"
export * from "./redirectUrlScanPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a407a5f",
  null
  
)

export default component.exports